import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStartPlayTimer = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M30.555 19.168L15.555 9.16796C15.248 8.96396 14.853 8.94396 14.529 9.11796C14.203 9.29196 14 9.63096 14 9.99996V30C14 30.369 14.203 30.708 14.528 30.882C14.676 30.961 14.838 31 15 31C15.194 31 15.388 30.943 15.555 30.832L30.555 20.832C30.833 20.646 31 20.334 31 20C31 19.666 30.833 19.354 30.555 19.168Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgStartPlayTimer);
export default ForwardRef;
